import props from './props'
import methods from './methods'
import data from './data'
import components from './components'
import mounted from './mounted'

export default {
  data,
  props,
  methods,
  components,
  mounted
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/resources/index.js